import * as React from 'react'

const { useState, useEffect } = React

interface Position {
  x: number
  y: number
}

interface BounceProps {
  cssPosition?: 'absolute' | 'fixed'
  initialPosition?: Position
  children: React.ReactNode
}

const randomPosition = () => ({ x: Math.random(), y: Math.random() })

const toPercent = (num: number): string => `${num * 100}%`

export const Bounce: React.FC<BounceProps> = ({
  cssPosition,
  initialPosition,
  children,
}) => {
  const [position, setPosition] = useState(initialPosition || randomPosition())

  const styles = {
    position: cssPosition || 'fixed',
    top: toPercent(position.y),
    left: toPercent(position.y),
  }

  return <div style={styles}>{children}</div>
}
